import Vue from 'vue';
import moment from 'moment';

export default {
  state: {
    commitsDifference: [],
    commitsDifferenceFilters: {},
    linesCounters: {},
    commitGroups: {}
  },

  mutations: {
    setCommitsDifference(state, payload) {
      state.commitsDifference = [...payload];
    },
    setCommitsDifferenceFilters(state, payload) {
      const filterObj = [];
      const addedFilters = [];
      if (payload) {
        payload.forEach((item) => {
          if (!item.fileExtension) {
            item.fileExtension = 'another';
            item.languageName = 'Другое';
          }
          if (addedFilters.includes(item.fileExtension)) return;

          addedFilters.push(item.fileExtension);
          filterObj.push({
            name: item.languageName,
            id: item.fileExtension,
            color: item.languageColor
          });
        });
      }

      Vue.set(state, 'commitsDifferenceFilters', filterObj);
    },
    setCommitsLinesCounters(state, payload) {
      state.linesCounters = payload;
    },
    setCommitGroups(state, payload) {
      const commitGroups = {};
      let lastDate;
      payload.commits.forEach((item) => {
        const date = moment(item.createdAt).format('DD.MM.YYYY');
        if (!lastDate) {
          lastDate = date;
          commitGroups[lastDate] = [];
        }

        if (lastDate !== date) {
          lastDate = date;
          commitGroups[lastDate] = [item];
        } else {
          commitGroups[lastDate].push(item);
        }
      });

      state.commitGroups = { hasNext: payload.hasNext, commits: commitGroups };
    },
  },

  actions: {
    setCommitsDifference(state, payload) {
      state.commit('setCommitsDifference', payload);
      state.commit('setCommitsDifferenceFilters', payload);
    },
    setCommitsLinesCounters(state, payload) {
      state.commit('setCommitsLinesCounters', payload);
    },
    setCommitGroups(state, payload) {
      state.commit('setCommitGroups', payload);
    }
  },

  getters: {
    getCommitsDifference(state) {
      return state.commitsDifference;
    },
    getCommitsDifferenceByExtension(state) {
      const filterObj = {};
      if (state.commitsDifference) {
        state.commitsDifference.forEach((item) => {
          if (filterObj[item.fileExtension]) {
            filterObj[item.fileExtension].push(item);
            return;
          }

          filterObj[item.fileExtension] = [item];
        });
        return filterObj;
      }
    },
    getCommitsDifferenceFilters(state) {
      return state.commitsDifferenceFilters;
    },
    getCommitsLinesCounters(state) {
      return state.linesCounters;
    },
    getCommitChangedFilesNumber(state) {
      return state.commitsDifference?.length;
    },
    getCommitGroups(state) {
      return state.commitGroups;
    }
  }
};
